//Converter a data recebendo uma string e passando para ano mês (YYYY-MM)
const convertDataStrToYYYYmm = (dateString) => {
    const date = new Date(dateString);
    return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}`;
};

//Converter a data recebendo uma string e passando para ano mês (MM-YYYY)
const convertDataStrToMMyyyy = (dateStr) => {
    const date = new Date(dateStr);
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return `${month < 10 ? "0" : ""}${month}/${year}`;
};

//Converter a data recebendo uma string (MM-YYYY) e passando para ano mês (Fri Apr 04 2025 16:27:32 GMT-0300 (Horário Padrão de Brasília))
function convertDataMMYYYYstrToData(dataStr) {
    const [mes, ano] = dataStr.split('-').map(Number);
    const date = new Date(ano, mes - 1, 4, 16, 27, 32);
    return date;
}

//Converter a data recebendo uma data (Fri Apr 04 2025 16:27:32 GMT-0300 (Horário Padrão de Brasília)) e passando para ano mês string (MM-YYYY) 
function convertDataToMMyyyyStr(data) {
    const date = new Date(data);
    const month = String(date.getMonth() + 1).padStart(2, '0'); 
    const year = date.getFullYear();

    return `${month}-${year}`;
}

//Converter a data por split '/' retornando YYYY-MM-DD
const convertDataSplitYYYYmmDD = (data) => {
    const [day, month, year] = data.split('/');
    return `${year}-${month}-${day}`;
};

//Converter a data por split '/' retornando dd/mm/yyyy
const convertDataToDDmmYYYY = (data) => {
const [ano, mes, dia] = data.split('-');
  return `${dia}/${mes}/${ano}`;
}

//Converter a data 2025-07-21T13:58:16.000Z para 21-Jul-2025 com opção de hora | 13:58:16 
const convertDataToDDmmExtenseYYYY = (data, withHour) => {
    const date = new Date(data);

    const day = String(date.getDate()).padStart(2, '0');
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();

    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    let formattedDate = `${day}-${month}-${year}`;

    if (withHour) {
        formattedDate += ` | ${hours}:${minutes}:${seconds}`;
    }
    return formattedDate;
}

//Retorna anos de 1999 até o ano atual
const getAnos = () => {
    const anoAtual = new Date().getFullYear();
    const anos = [];

    for (let a = (anoAtual) + 3; a >= 1999; a--) {
        anos.push(a.toString());
    }
    return anos;
};

const getAnosToMultiSelect = () => {
    const listaDeAnos = getAnos().map(year => ({
        label: year,
        value: year
    }));
    return listaDeAnos;
}

function getNextMonthYear(input) {
    const [month, year] = input.split('-').map(Number);
    const date = new Date(year, month - 1);
    date.setMonth(date.getMonth() + 1);

    const nextMonth = String(date.getMonth() + 1).padStart(2, '0');
    const nextYear = date.getFullYear();

    return `${nextMonth}-${nextYear}`;
}

// Converte data em formato ex: 2025-06-24T19:47:14.000Z para 24/06/2025
const convertISOdateToDDmmYYYY = (isoDate) => {
    const date = new Date(isoDate);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
};

const ConvertDataService = {
    convertDataStrToYYYYmm,
    convertDataStrToMMyyyy,
    convertDataSplitYYYYmmDD,
    convertDataToDDmmYYYY,
    getAnos,
    getAnosToMultiSelect,
    getNextMonthYear,
    convertDataMMYYYYstrToData,
    convertDataToMMyyyyStr,
    convertISOdateToDDmmYYYY,
    convertDataToDDmmExtenseYYYY
}

export default ConvertDataService;